<template>
	<div class="page">
		<Tip :title="title" />
		<div class="tag">
			<span>{{tag}}</span>
		</div>
		<div class="from_div">
			<!--退款处理-->
			<el-form label-position="left" label-width="100px">
				<el-form-item label="订单金额：">
					<span>￥{{detail.cost_amount}}</span>
				</el-form-item>
				<el-form-item label="退款金额：">
					<el-input class="input" v-model="refund_money" placeholder="请输入金额"></el-input>
				</el-form-item>
			</el-form>
		</div>
		<div class="foot_div">
			<el-button @click="close">返回</el-button>
			<el-button type="primary" @click="submit">确定</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
    import {
		afterRefund,
        afterDetail
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip
		},
		props: {
			type: Number,
            arr: Array
		},
		data() {
			return {
				title: '退款',
				tag: '对售后商品的申请进行退款操作：',
                detail: {},
                refund_money: '',
			}
		},
		mounted() {
            this.getAfterDetail();
        },
		methods: {
            getAfterDetail(){
                afterDetail({after_sale_id: this.type}).then(res => {
                    if (res.code == 0) {
                        this.detail = res.data;
                    }else{
                        this.$message({ type: 'error', message: res.msg });
                        return this.$emit('close', 0);
                    }
                }).catch(err => {})
            },

            submit() {
                if(this.refund_money <= 0){
                    return this.$message({ type: 'error', message: '请填写正确的退款金额' });
                }
                if(this.refund_money > this.detail.sale_amount){
                    return this.$message({ type: 'error', message: '退款金额不能大于订单金额' });
                }

                var params = {
                    after_sale_id: this.type,
                    refund_money: this.refund_money
                };
                afterRefund(params).then(res => {
                    if (res.code == 0) {
                        this.$message({ type: 'success', message: res.msg || '操作成功!' });
                        this.$emit('close', 1)
                    }else{
                        console.log('submit error', params)
                        return this.$message({ type: 'error', message: res.msg });
                    }
                }).catch(err => {})
            },

			close() {
				this.$emit('close')
			}
		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: relative;
	}

	.tag {
		font-size: 14px;
		color: #000;
		padding-top: 20px;
	}

	.row {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.col {
		display: flex;
		flex-direction: column;
	}
	
	.radio{
		margin-bottom: 30px;
		font-size: 14px;
		color: #000;
	}
	
	.style_{
		font-size: 14px;
		color: #000;
	}
	
	.input{
		width: 235px;
	}

	.from_div {
		padding-top: 20px;
		width: 100%;
		/* overflow: scroll; */
		/* height: 570px; */
		min-height: 100%;
		padding-bottom: 66px;
	}

	.select {
		width: 235px;
		margin-bottom: 20px;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}

	.span {
		font-size: 14px;
		color: #767676;
	}
</style>